<template>
  <router-view />
</template>

<script>
export default {
  name: "SettingComponent",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch("Profile/getAllSetup");
      window.document.title = "KISEB::Account Settings";
    });
  },
  methods: {},
};
</script>

<style scoped></style>
